import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '@core/models/api-response.model';
import { Pagination } from '@core/models/pagination.model';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Observable, Subject } from 'rxjs';
import { map, tap, concatMap } from 'rxjs/operators';
import { Marquees } from '@core/models/marquees.model';

@Injectable()
export class MarqueesDataService extends DefaultDataService<Marquees>{
  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
    super('Marquees', http, httpUrlGenerator, { root: '' });
  }

  getWithQuery(pageParam: string): Observable<Marquees[]> {
    return this.http.get<ApiResponse>(`/marquees${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => {
        Object.keys(res.data.rows).forEach(x => {
          let localeList = [];

          Object.keys(res.data.rows[x].contents).forEach(y => {
            if (res.data.rows[x].contents[y].content) {
              localeList.push(res.data.rows[x].contents[y].locale_name);
            }
          })
          res.data.rows[x].locale_list = localeList.toString().split(',').join(', ');
        })
        return res.data.rows
      }
    ));
  }

  addMarque(param: any) {
    return this.http.post<ApiResponse>(`/marquees`, param).pipe(
      tap(res => this.messages$.next(res.message)),
    );
  }

  updateMarquee(id: number, param: any) {
    return this.http.put<ApiResponse>(`/marquees/${id}`, param).pipe(
      tap(res => this.messages$.next(res.message)),
    );
  }

  updateStatus(param: any) {
    return this.http.post<ApiResponse>(`/marquees/updatestatus`, param).pipe(
      tap(res => this.messages$.next(res.message)),
    );
  }

  duplicate(param: any) {
    return this.http.post<ApiResponse>(`/marquees/duplicate`, param).pipe(
      tap(res => this.messages$.next(res.message)),
    );
  }

  private paginationInit(res: any) {
    if (res) {
      this.pagination = res.data.paginations;
    }
  }
}